// Auto-generated for /pages/about during Magento → Shopify migration.
// Loaded with <script defer> so DOM is ready before this runs.

(function() {
    'use strict';

    var TRUST_BADGES = [
        { icon: 'veteran', title: 'Veteran Owned', subtitle: 'Proudly a veteran owned business' },
        { icon: 'family', title: 'Family Operated', subtitle: 'Still going strong' },
        { icon: 'usa', title: 'Small Business', subtitle: 'American owned & operated' }
    ];

    var STATS = [
        { number: '30+', label: 'Years in Business' },
        { number: '10K+', label: 'Products in Stock' },
        { number: '100+', label: 'Brands Carried' },
        { number: '24hr', label: 'Typical Ship Time' }
    ];

    var VALUES = [
        {
            icon: 'phone',
            title: 'Real People, Real Answers',
            description: 'Call us and a knowledgeable team member picks up—no automated menus, no waiting on hold. We answer your questions quickly and accurately.'
        },
        {
            icon: 'inventory',
            title: 'Stocked & Ready to Ship',
            description: 'We maintain deep inventory on the products you need most. When you place an order, it ships fast because we stock what we sell.'
        },
        {
            icon: 'handshake',
            title: 'Relationships Over Transactions',
            description: 'We succeed when you succeed. That mindset shapes every interaction, from product recommendations to resolving issues.'
        }
    ];

    var SERVICES = [
        {
            icon: 'support',
            title: 'Fast, Friendly Order Support',
            description: 'Prefer to call in your orders? Our customer support team is ready at 847-639-4700 to take your order, provide quotes, or answer questions. A real person will pick up promptly—that\'s our promise.'
        },
        {
            icon: 'technical',
            title: 'Expert Technical Assistance',
            description: 'Can\'t find what you\'re looking for? Our product managers are extensively trained on everything we sell. They\'ll help you select the right product for your application and answer technical questions.'
        },
        {
            icon: 'custom',
            title: 'Custom Sourcing & Solutions',
            description: 'Need something specialized? We work with over 100 manufacturers and can source products outside our standard catalog. Tell us what you need and we\'ll find it.'
        },
        {
            icon: 'account',
            title: 'Flexible Account Options',
            description: 'We offer Net 30 terms for qualified accounts, accept all major credit cards, and can set up blanket orders to lock in pricing. Our goal is to make purchasing easy.'
        }
    ];

    var ICONS = {
        veteran: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"></path><path d="M2 17l10 5 10-5"></path><path d="M2 12l10 5 10-5"></path></svg>',
        family: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>',
        usa: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>',
        phone: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>',
        inventory: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>',
        handshake: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>',
        support: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>',
        technical: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>',
        custom: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
        account: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>'
    };

    function createTrustBadge(badge) {
        var el = document.createElement('div');
        el.className = 'trust-badge';
        el.innerHTML = '<div class="trust-badge-icon">' + ICONS[badge.icon] + '</div>' +
            '<div class="trust-badge-text">' +
            '<strong>' + badge.title + '</strong>' +
            '<span>' + badge.subtitle + '</span>' +
            '</div>';
        return el;
    }

    function createStatCard(stat) {
        var el = document.createElement('div');
        el.className = 'stat-card';
        el.innerHTML = '<div class="stat-number">' + stat.number + '</div>' +
            '<div class="stat-label">' + stat.label + '</div>';
        return el;
    }

    function createValueCard(value) {
        var el = document.createElement('div');
        el.className = 'value-card';
        el.innerHTML = '<div class="value-icon">' + ICONS[value.icon] + '</div>' +
            '<h3>' + value.title + '</h3>' +
            '<p>' + value.description + '</p>';
        return el;
    }

    function createServiceCard(service) {
        var el = document.createElement('div');
        el.className = 'service-card';
        el.innerHTML = '<div class="service-icon">' + ICONS[service.icon] + '</div>' +
            '<div class="service-content">' +
            '<h3>' + service.title + '</h3>' +
            '<p>' + service.description + '</p>' +
            '</div>';
        return el;
    }

    function render(containerId, items, createFn) {
        var container = document.getElementById(containerId);
        if (!container) return;
        var fragment = document.createDocumentFragment();
        items.forEach(function(item) {
            fragment.appendChild(createFn(item));
        });
        container.appendChild(fragment);
    }

    function init() {
        render('trustBadges', TRUST_BADGES, createTrustBadge);
        render('storyStats', STATS, createStatCard);
        render('valuesGrid', VALUES, createValueCard);
        render('servicesGrid', SERVICES, createServiceCard);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();